<template>
  <div class="profileContent">
    <div class="actionList" ref="profileUser">
      <profile :source="dataProfile" />

      <v-list-item class="config-item" color="white" @click="goToPage('Favs')">
        <v-list-item-content>
          <v-list-item-title class="title " style="color:black">
            <div :style="styles">Mis favoritos</div>
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-icon style="color:gray">mdi-chevron-right</v-icon>
        </v-list-item-action>
      </v-list-item>

      <v-list-item
        @click="goToPage('EditProfile')"
        :source="dataProfile"
        class="config-item"
        color="white"
        v-if="!hasRelativeRole"
      >
        <v-list-item-content>
          <v-list-item-title class="title " style="color:black">
            <div :style="styles">Editar perfil</div>
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-icon style="color:gray">mdi-chevron-right</v-icon>
        </v-list-item-action>
      </v-list-item>

      <v-list-item
        class="config-item"
        color="white"
        @click="
          onLinkClick({
            uri:
              'https://www.colegiohispanoingles.com/wp-content/uploads/2020/09/Reglamento_de_convivencia.pdf'
          })
        "
      >
        <v-list-item-content>
          <v-list-item-title class="title " style="color:black">
            <div :style="styles">Reglamento interno</div>
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-icon style="color:gray">mdi-chevron-right</v-icon>
        </v-list-item-action>
      </v-list-item>
      <div class="list-item-separator"></div>
      <v-list-item class="config-item close" color="white" @click="logOut">
        <v-list-item-content>
          <v-list-item-title class="title " style="color:red">
            <div :style="styles">Cerrar sesión</div>
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-icon style="color:gray">mdi-chevron-right</v-icon>
        </v-list-item-action>
      </v-list-item>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Profile from '@/components/profile/index'
import actions from '@chi-x/chi-login/lib/actions'
import { openLink } from '@/utils/ReactNative'
import { convertEmToPixels } from '@/helper/helper'
import { RegisterEvent } from '@/analytics'
import { _ } from 'vue-underscore'

export default {
  name: 'Profile',
  created: function () {
    this.loading = true
    this.callProfileAction()
  },
  data () {
    return {
      roleRelative: true
    }
  },

  components: { profile: Profile },
  computed: {
    ...mapGetters(['getProfileData']),
    styles () {
      const result = convertEmToPixels(19)
      return {
        'font-size': result + 'px',
        'line-height': `${result + 2}px`,
        'font-weight': '400'
      }
    },
    hasRelativeRole () {
      const { roles } = this.getProfileData
      return roles && _.indexOf(roles, 'relative') >= 0
    },
    dataProfile () {
      return this.getProfileData
    }
  },
  methods: {
    ...mapActions({
      profileAction: 'GET_PROFILE',
      favAction: 'GET_FAVS',
      resetAuthor: 'RESET_AUTHORS_ACTION',
      resetFavs: 'RESET_LIKES_ACTION',
      resetLikes: 'RESET_LIKES_ACTION',
      resetNotifications: 'RESET_NOTIFS_ACTION',
      resetPosts: 'RESET_POSTS_ACTION',
      resetProfile: 'RESET_PROFILE_ACTION',
      resetShares: 'RESET_SHARES_ACTION',
      resetSystem: 'RESET_SYSTEM_ACTION',
      resetTags: 'RESET_TAGS_ACTION',
      resetVideos: 'RESET_VIDEOS_ACTION',
      resetDevices: 'RESET_DEVICES_ACTION',
      update_realtime: 'UPDATE_DEVICE'
    }),

    callProfileAction () {
      this.profileAction().then(() => (this.loading = false))
    },
    logOut () {
      RegisterEvent('chi_user_logout', {
        target_id: 'logout',
        target_type: 'global_event'
      })
      this.update_realtime()
      const dispatchLogout = this.$store.dispatch(actions.AUTH_LOGOUT)
      this.resetAuthor()
      this.resetFavs()
      this.resetLikes()
      this.resetNotifications()
      this.resetPosts()
      this.resetProfile()
      this.resetShares()
      this.resetSystem()
      this.resetTags()
      this.resetVideos()
      this.resetDevices()
      return dispatchLogout
    },
    goToPage (pageName) {
      RegisterEvent('chi_menu_selected', {
        target_id: pageName,
        target_type: 'menu_name'
      })
      return this.$router.push({ name: pageName })
    },
    onLinkClick (link) {
      openLink(link)
      RegisterEvent('chi_url_open', {
        target_id: link.uri,
        target_type: 'link'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Profile.vue